import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./outras-receitas-listar/outras-receitas-listar.module').then(m => m.OutrasReceitasListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./outras-receitas-inserir/outras-receitas-inserir.module').then(m => m.OutrasReceitasInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./outras-receitas-editar/outras-receitas-editar.module').then(m => m.OutrasReceitasEditarModule) }
    ])],
    exports: [RouterModule]
})
export class OutrasReceitasAppRoutingModule { }